import { Injectable } from '@angular/core';
import { BaseEndpointCRUD } from '@m4u-angular/base/endpoint/BaseEndpointCRUD';
import { BaseDataResponse, BaseEntitiesResponse, NotificationTemplate, NotificationTemplateListView } from '@m4u-angular/base/entities/BaseEntities';
import { APIGatewayService } from '../gateway/APIGateway.service';
import { Observable } from 'rxjs';

@Injectable()
export class NotificationTemplateEndpoint extends BaseEndpointCRUD<NotificationTemplate> {
    constructor(api: APIGatewayService) {
        super('NotificationTemplate', api);
    }

    public UpdateIsUserCustomTemplate(oTemplate: NotificationTemplate): Observable<BaseDataResponse<boolean>> {
        return this.api.ExecutePostAction(this.ControllerName, 'UpdateIsUserCustomTemplate', oTemplate);
    }

    public GetListViews(): Observable<BaseEntitiesResponse<NotificationTemplateListView>> {
        return this.api.ExecuteGetAction(this.ControllerName, 'GetListViews', {});
    }
}